module.exports = __webpack_public_path__ + "img/img-yingjian-s3.878e0484.jpg";